// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Qi2QXg9Apv3nSj {\n  display: flex;\n  padding: 8px 16px;\n}\n._1WJ_grlZ_8BmB7 {\n  display: flex;\n  flex-grow: 1;\n  flex-basis: 100%;\n}\n._1WJ_grlZ_8BmB7._1aXwzmif2Lqvtx {\n  justify-content: flex-start;\n}\n._1WJ_grlZ_8BmB7.-eWrgZ2xAAIjWI {\n  justify-content: flex-end;\n}\n._1TuHixIaB9LuYp {\n  font-size: 16px;\n  line-height: 32px;\n  font-weight: 500;\n}\n.aSF4S9SBzpc5ld {\n  margin-left: 20px;\n}\n.aSF4S9SBzpc5ld .KbdGpUASikEAOX {\n  margin: 0 2px;\n  height: 32px;\n  padding: 0 8px;\n}\n._18K0NKCKnURlWU {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n._3BgPRR-3-QatX8 {\n  border-left: 1px solid #F4F5F7;\n  height: 16px;\n  margin: 8px 4px 8px 6px;\n  border-radius: 10px 10px 0 0;\n}\n._2u_Jtk-3pL8a3q {\n  display: inline-flex;\n  margin: 0 4px;\n}\n.H8sh5e4FxN2_B1 {\n  margin: auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n._3W1ADU1AUo2830 {\n  vertical-align: middle;\n  padding-left: 8px;\n}\n._3F8Zec92_FMPhX {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n.Pkg2NL7xZyDJQ6 {\n  position: absolute;\n  right: 14px;\n}\n._206M232FCqLdVI {\n  display: block;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": "Qi2QXg9Apv3nSj",
	"headerSection": "_1WJ_grlZ_8BmB7",
	"leftSection": "_1aXwzmif2Lqvtx",
	"rightSection": "-eWrgZ2xAAIjWI",
	"dateText": "_1TuHixIaB9LuYp",
	"navigationButtons": "aSF4S9SBzpc5ld",
	"navigationButton": "KbdGpUASikEAOX",
	"closeButton": "_18K0NKCKnURlWU",
	"divider": "_3BgPRR-3-QatX8",
	"select": "_2u_Jtk-3pL8a3q",
	"dropdownButton": "H8sh5e4FxN2_B1",
	"dropdownButtonIcon": "_3W1ADU1AUo2830",
	"dropdownButtonText": "_3F8Zec92_FMPhX",
	"dropdownCheck": "Pkg2NL7xZyDJQ6",
	"label": "_206M232FCqLdVI"
};
export default ___CSS_LOADER_EXPORT___;
